import type { Locale } from "@/lib/i18n/locales";
import { brevoDemoUrl } from "@/lib/slRoutes";

/** Meeting type slug in Brevo (German label); add localized meeting types in Brevo to use different `l` values per locale. */
const brevoMeetingSlug = "kostenfreie-erstberatung";

/**
 * Borderless embed URL for the Erstberatung calendar. Passes `lang` so Brevo can
 * show UI in the site locale when supported (falls back to German otherwise).
 */
export function getBrevoBorderlessCalendarSrc(siteLocale: Locale): string {
  const lang: string =
    siteLocale === "de"
      ? "de"
      : siteLocale === "fr"
        ? "fr"
        : siteLocale === "zh"
          ? "zh"
          : siteLocale === "ja"
            ? "ja"
            : "en";
  const q = new URLSearchParams({ l: brevoMeetingSlug, lang });
  return `${brevoDemoUrl}/borderless?${q.toString()}`;
}
